import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Discover the Joy of Hiking, Camping, and Trekking"} subTitle={"Become a Trailblazer"} linear sideHeading />
        <Button link={"Tours"} title={"View Tours"} />

      </div>
    </section>
  );

};

export default Banner;